export const metricMaxValueMap = {
  sentiment: 5
};